import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { StorageService } from 'src/app/layout/components/storage/storage.service';
import {
    BehaviorSubject,
    catchError,
    map,
    Observable,
    of,
    Subject,
    finalize,
    throwError,
    filter,
} from 'rxjs';

import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
const helperJWT = new JwtHelperService();

import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private basePath = environment.interop.authCore.basePath;
    private paymentsBasePath = environment.interop.basePath;

    private getUserDetailsUrl =
        this.basePath + environment.interop.authCore.platform.getUserDetails;
    private authorizeShortTokenUrl = this.paymentsBasePath + environment.interop.payments.authorizeShortToken;

    private token: any;

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }),
    };
    clearStorage: any;

    constructor(
        private storageService: StorageService,
        private http: HttpClient,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) { }

    isTokenExpired(token: string): boolean {
        const isExpired = helperJWT.isTokenExpired(token);
        return isExpired;
    }

    async setToken(token: string) {
        return this.storageService.setString(environment.config.tokenKey, token);
    }

    async returnTokenUser() {
        return this.storageService.getString(environment.config.tokenKey);
    }

    async getToken(): Promise<string> {
        const tokenObj = await this.returnTokenUser();
        this.token = tokenObj;
        return tokenObj;
    }

    verifyToken(token: any): Observable<boolean> {
        if (token == undefined || token == null || token == '') {
            return of(this.redirectToLogin());
        }

        const isExpired = helperJWT.isTokenExpired(token);
        // console.log(isExpired, 'isExpired or not?')
        if (isExpired) {
            // attempt to refresh?
            // console.log('token expired, please redirect?')
            // else, redirect to login

            return of(this.redirectToLogin());
        } else {
            const decodedToken = helperJWT.decodeToken(token);
            // console.log(decodedToken, 'decodedToken')
            // get userDetails from here pls
            if (environment.config.fromTokenValid !== decodedToken.iss) {
                // console.log('token not valid, please redirect?')

                return of(this.redirectToLogin());
            } else {
                // console.log('token valid, please continue?')
                // try to fetch the details in silence so we can go on with the application of course
                //await this.getUserDetails(token)
                return of(true);
            }
        }
    }

    redirectToLogin() {
        window.location.href = environment.interop.authCore.linkRedirectAuth;
        return false;
    }

    getUserDetails(token: string) {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
        });

        return this.http.get(`${this.getUserDetailsUrl}`, { headers });
    }

    async hasTokenAndUserDetails(): Promise<boolean> {
        const token = await this.storageService.getString(
            environment.config.tokenKey
        );
        const userDetails = await this.storageService.getObject(
            environment.config.userKey
        );

        return !!token && !!userDetails;
    }

    removeTokenFromUrl() {
        // Get the current query parameters
        this.activatedRoute.queryParamMap.subscribe((params: ParamMap) => {
            // Create a new params object without the token parameter
            const newParams: any = {};
            params.keys.forEach((key) => {
                if (key !== 'token') {
                    newParams[key] = params.get(key);
                }
            });

            // Navigate to the current route with the updated query parameters
            this.router.navigate([], {
                relativeTo: this.activatedRoute,
                queryParams: newParams,
            });
        });
    }

    authorizeShortToken(shortToken: string) {
        return this.http.get(`${this.authorizeShortTokenUrl}${shortToken}`);
    }
}
